/* darette-variant-cards.js v2 (2026-09-02 CC speedfix)
 * v1 problems (PSI: forced reflow 6.9s, long task 4.3s on /collections/all):
 *  - MutationObserver on document.documentElement -> every lazy image / any DOM change re-swept all cards
 *  - paint() re-ran on already painted cards, toggling hidden attrs + reading offsetWidth (forced sync layout)
 *  - set img.loading="eager" -> sizes="auto" fell back to 100vw and pulled width=832 for 200px cards
 * v2: paint each card once (idempotent flag), observe only the product grid, never read layout, keep lazy.
 */
(function(){
  var SEL='li.dt-vcard[data-vmid]';
  function paint(li){
    var mid=li.getAttribute('data-vmid');
    if(!mid) return;
    if(li.__dtPainted===mid) return;
    var vid=li.getAttribute('data-vid'), cname=li.getAttribute('data-vcolor')||'';
    var target=li.querySelector('slideshow-slide[slide-id="'+mid+'"]');
    if(!target) return; /* card body not rendered yet; observer will bring us back when it lands */
    if(target.hasAttribute('hidden')){
      li.querySelectorAll('slideshow-slide').forEach(function(s){
        if(s!==target&&!s.hasAttribute('hidden')){ s.setAttribute('hidden',''); s.setAttribute('aria-hidden','true'); }
      });
      target.removeAttribute('hidden'); target.setAttribute('aria-hidden','false');
      var im=target.querySelector('img'); if(im) im.removeAttribute('hidden'); /* keep loading=lazy: browser fetches on-screen ones immediately anyway */
    }
    if(vid){
      li.querySelectorAll('a[href*="/products/"]').forEach(function(a){
        var h=a.getAttribute('href')||'';
        if(h.indexOf('variant='+vid)>-1) return;
        h=/[?&]variant=\d+/.test(h)?h.replace(/([?&]variant=)\d+/,'$1'+vid):h+(h.indexOf('?')>-1?'&':'?')+'variant='+vid;
        a.setAttribute('href',h);
      });
    }
    if(cname&&!li.querySelector('.dt-vcard__color')){
      /* pick the title without touching layout: first candidate not inside a [hidden] subtree */
      var cands=li.querySelectorAll('.dar-tr a, .title-text, product-title, h3, h4'), t=null;
      for(var i=0;i<cands.length;i++){ if(!cands[i].closest('[hidden]')){ t=cands[i]; break; } }
      if(t&&t.textContent.indexOf(cname)===-1) t.insertAdjacentHTML('beforeend','<span class="dt-vcard__color"> — '+cname+'</span>');
    }
    li.__dtPainted=mid;
  }
  function sweepAll(){ document.querySelectorAll(SEL).forEach(paint); }
  function sweepRecords(records){
    var seen=[];
    var touch=function(el){ if(el&&seen.indexOf(el)===-1){ seen.push(el); paint(el); } };
    for(var i=0;i<records.length;i++){
      var n=records[i].target; if(!n||!n.closest) continue;
      touch(n.closest(SEL));
      var added=records[i].addedNodes;
      for(var j=0;j<added.length;j++){ var a=added[j]; if(!a||!a.querySelectorAll) continue; if(a.matches&&a.matches(SEL)) touch(a); a.querySelectorAll(SEL).forEach(touch); }
    }
  }
  var pending=[], queued=false;
  function schedule(records){
    if(records&&records.length) pending.push.apply(pending,records);
    if(queued) return; queued=true;
    requestAnimationFrame(function(){ queued=false; var b=pending; pending=[]; if(b.length) sweepRecords(b); else sweepAll(); });
  }
  function boot(){
    sweepAll();
    var root=document.getElementById('ResultsList')||document.querySelector('results-list')||document.querySelector('.product-grid');
    if(root&&!root.__dtVcObs){ root.__dtVcObs=1; new MutationObserver(schedule).observe(root,{childList:true,subtree:true}); }
  }
  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded',boot);
  window.addEventListener('load',function(){ sweepAll(); });
  document.addEventListener('shopify:section:load',boot);
})();
